import { apiPost, apiGet } from './client';
import { getApiBaseUrl } from '../utils/config';

export interface StoreKioskSettings {
  takeoutEnabled: boolean;
  averageMinutesPerTeam: number;
  averageMinutesPerTakeout: number;
}

export async function getStoreKioskSettings(storeId: string): Promise<StoreKioskSettings> {
  try {
    return await apiGet<StoreKioskSettings>(
      `/api/stores/${encodeURIComponent(storeId)}/settings`,
    );
  } catch {
    return { takeoutEnabled: false, averageMinutesPerTeam: 10, averageMinutesPerTakeout: 15 };
  }
}

export interface WaitingResult {
  waitingNumber: number;
  ahead: number;
  estimatedMinutes: number;
  visitCount?: number;
}

interface RegisterWaitingBody {
  phone: string;
  partySize: number;
  language?: string;
  orderType?: string;
  orderItems?: { menuId: string; quantity: number }[];
}

/**
 * 대기 등록 API 호출
 */
export async function registerWaiting(
  storeId: string,
  phone: string,
  partySize: number,
  language?: string,
  orderType?: string,
  orderItems?: { menuId: string; quantity: number }[],
): Promise<WaitingResult> {
  const body: RegisterWaitingBody = { phone, partySize };
  if (language) {
    body.language = language;
  }
  if (orderType) {
    body.orderType = orderType;
  }
  if (orderItems && orderItems.length > 0) {
    body.orderItems = orderItems;
  }
  return apiPost<WaitingResult>(
    `/api/stores/${encodeURIComponent(storeId)}/waitings`,
    body,
  );
}

/**
 * 숏코드로 매장 정보 조회
 */
export interface ShortCodeResult {
  storeId: string;
  storeName: string;
  shortCode: string;
}

export async function resolveShortCode(shortCode: string): Promise<ShortCodeResult> {
  const baseUrl = getApiBaseUrl();
  const url = `${baseUrl}/api/stores/code/${encodeURIComponent(shortCode.toUpperCase())}`;

  let response: Response;
  try {
    response = await fetch(url);
  } catch {
    throw new Error('네트워크 오류가 발생했습니다.');
  }

  if (!response.ok) {
    throw new Error('매장을 찾을 수 없습니다.');
  }

  const json = await response.json() as { success: boolean; data?: ShortCodeResult; error?: string };

  if (!json.success || !json.data) {
    throw new Error(json.error ?? '매장을 찾을 수 없습니다.');
  }

  return json.data;
}
